import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaWallet, FaUser, FaUsers, FaExchangeAlt } from 'react-icons/fa';
import { useAuthStore } from '../../../store/authStore';
import './BottomNav.css';

const BottomNav = () => {
    const location = useLocation();
    const { isAdmin } = useAuthStore();

    const isActive = (path) => location.pathname === path;

    if (isAdmin()) {
        return (
            <nav className="bottom-nav">
                <Link to="/admin" className={`nav-action ${isActive('/admin') ? 'active' : ''}`}>
                    <FaHome className="nav-icon" />
                    <span className="nav-label">Home</span>
                </Link>
                <Link to="/admin/users" className={`nav-action ${isActive('/admin/users') ? 'active' : ''}`}>
                    <FaUsers className="nav-icon" />
                    <span className="nav-label">Users</span>
                </Link>
                <Link to="/admin/payments" className={`nav-action ${isActive('/admin/payments') ? 'active' : ''}`}>
                    <FaWallet className="nav-icon" />
                    <span className="nav-label">Payments</span>
                </Link>
                <Link to="/settings" className={`nav-action ${isActive('/settings') ? 'active' : ''}`}>
                    <FaUser className="nav-icon" />
                    <span className="nav-label">Me</span>
                </Link>
            </nav>
        );
    }

    return (
        <nav className="bottom-nav">
            <Link to="/dashboard" className={`nav-action ${isActive('/dashboard') ? 'active' : ''}`}>
                <FaHome className="nav-icon" />
                <span className="nav-label">Home</span>
            </Link>
            <Link to="/transactions" className={`nav-action ${isActive('/transactions') ? 'active' : ''}`}>
                <FaExchangeAlt className="nav-icon" />
                <span className="nav-label">Transaction</span>
            </Link>
            <Link to="/payments" className={`nav-action ${isActive('/payments') ? 'active' : ''}`}>
                <FaWallet className="nav-icon" />
                <span className="nav-label">Payment</span>
            </Link>
            <Link to="/settings" className={`nav-action ${isActive('/settings') ? 'active' : ''}`}>
                <FaUser className="nav-icon" />
                <span className="nav-label">Me</span>
            </Link>
        </nav>
    );
};

export default BottomNav;
